import { useState, useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { getEditor } from '../../../api/admin/editors';
const useEditorFormState = (editorId) => {
    const dispatch = useAppDispatch();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [isStateReady, setIsStateReady] = useState(false);
    const [updatedFormFields, setUpdatedFormFields] = useState(() => new Set());
    useEffect(() => {
        if (editorId) {
            const fetchEditorData = async () => {
                try {
                    const editor = await getEditor(editorId);
                    setFirstName(editor.firstName);
                    setLastName(editor.lastName);
                    setEmail(editor.email);
                    setIsActive(editor.isActive);
                    setIsStateReady(true);
                }
                catch (error) {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
            };
            fetchEditorData();
        }
        else {
            setIsStateReady(true);
        }
    }, []);
    return {
        formState: {
            firstName,
            setFirstName,
            lastName,
            setLastName,
            email,
            setEmail,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            isActive,
            setIsActive,
        },
        updatedFormFields,
        setUpdatedFormFields,
        isStateReady,
    };
};
export default useEditorFormState;
